{
  "acorn-squash": {
    "name": "橡果南瓜",
    "description": "橡果南瓜是葫芦科植物，因形状像橡果而得名。果实小而圆，橙色或绿色果皮，果肉香甜软糯，富含维生素A和膳食纤维。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "adjuma-pepper": {
    "name": "阿茹玛辣椒",
    "description": "阿茹玛辣椒是茄科植物，原产于南美洲。果实小型到中型，辣度中等，独特的柑橘风味，常用于加勒比地区料理。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "aji-dulce-pepper": {
    "name": "阿吉杜尔塞辣椒",
    "description": "阿吉杜尔塞辣椒是茄科植物，原产于南美洲。果实外观像哈瓦那辣椒但无辣味，带有独特的水果香气，常用于南美料理。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "aleppo-pepper": {
    "name": "阿勒颇辣椒",
    "description": "阿勒颇辣椒是茄科植物，原产于叙利亚。果实干燥后磨成粉，辣度中等，带有浓郁的果香和盐味，是中东料理的重要调味料。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "almond": {
    "name": "杏仁",
    "description": "杏仁是蔷薇科乔木，原产于中亚。坚果富含蛋白质、维生素E和健康脂肪，是全球重要的坚果作物。",
    "sun_requirements": "全日照",
    "sowing_method": "嫁接育苗"
  },
  "anaheim-pepper": {
    "name": "阿纳海姆辣椒",
    "description": "阿纳海姆辣椒是茄科植物，原产于新墨西哥州。果实长而直，辣度较低，常用于制作辣椒酱或烤制。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "apple": {
    "name": "苹果",
    "description": "苹果是蔷薇科乔木，原产于中亚。果实圆形，果皮红绿相间，口感脆甜，富含膳食纤维、维生素C和抗氧化物质，是世界主要水果之一。",
    "sun_requirements": "全日照",
    "sowing_method": "嫁接育苗"
  },
  "apricot": {
    "name": "杏子",
    "description": "杏子是蔷薇科乔木，原产于中国。果实橙黄色，果肉柔软多汁，富含维生素A和C，酸甜可口。",
    "sun_requirements": "全日照",
    "sowing_method": "嫁接育苗"
  },
  "artichoke": {
    "name": "朝鲜蓟",
    "description": "朝鲜蓟是菊科多年生植物，原产于地中海地区。未开放的花蕾可食用，口感独特，富含膳食纤维和抗氧化物质，被誉为'蔬菜之王'。",
    "sun_requirements": "全日照",
    "sowing_method": "育苗移栽"
  },
  "arugula": {
    "name": "芝麻菜",
    "description": "芝麻菜是十字花科植物，原产于地中海地区。叶片呈深绿色，具有独特的辛辣香味，富含维生素和抗氧化物质，常用于沙拉。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "asian-pear": {
    "name": "亚洲梨",
    "description": "亚洲梨是蔷薇科乔木，原产于东亚。果实圆形或梨形，果皮黄褐色，果肉多汁脆甜，富含膳食纤维和维生素C。",
    "sun_requirements": "全日照",
    "sowing_method": "嫁接育苗"
  },
  "asparagus": {
    "name": "芦笋",
    "description": "芦笋是天门冬科多年生草本植物，原产于欧洲。嫩茎嫩绿，口感鲜嫩，富含叶酸、维生素K和膳食纤维，是高级蔬菜。",
    "sun_requirements": "全日照",
    "sowing_method": "种植根茎或播种育苗"
  },
  "banana-pepper": {
    "name": "香蕉辣椒",
    "description": "香蕉辣椒是茄科植物，因形状和颜色像香蕉而得名。果实黄色，辣度很低，口感甜脆，常用于沙拉和三明治。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "barley": {
    "name": "大麦",
    "description": "大麦是禾本科植物，原产于西亚。颗粒富含蛋白质和膳食纤维，是世界主要粮食和酿造原料之一。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "basil": {
    "name": "罗勒",
    "description": "罗勒是唇形科一年生草本植物，原产于印度。叶片芳香浓郁，富含维生素K和抗氧化物质，是地中海料理和意大利菜的重要香料。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "beet": {
    "name": "甜菜",
    "description": "甜菜是苋科植物，原产于地中海地区。根部为紫红色圆锥形，富含甜菜红素、叶酸和铁质，可食用和制糖。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "belgian-endive": {
    "name": "比利时菊苣",
    "description": "比利时菊苣是菊科植物，原产于比利时。叶片紧密包裹成圆锥形，质地脆嫩微苦，富含维生素K和叶酸，常用于沙拉。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "bibb-lettuce": {
    "name": "比布生菜",
    "description": "比布生菜是菊科植物，原产于美国。叶片松散柔软，质地细腻，口感甜脆，富含维生素A和K，是高档沙拉蔬菜。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种或育苗移栽"
  },
  "bing-cherry": {
    "name": "宾樱桃",
    "description": "宾樱桃是蔷薇科乔木，原产于美国。果实深红色，果肉甜美多汁，富含抗氧化物质和维生素C，是著名樱桃品种。",
    "sun_requirements": "全日照",
    "sowing_method": "嫁接育苗"
  },
  "birds-eye-chili": {
    "name": "鸟眼辣椒",
    "description": "鸟眼辣椒是茄科植物，原产于东南亚。果实小型，辣度极高，具有独特的柑橘香气，广泛用于东南亚料理。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "bishops-crown-pepper": {
    "name": "主教冠辣椒",
    "description": "主教冠辣椒是茄科植物，因果实形状像主教冠而得名。果实红色，辣度中等，带有独特的果香，常用于装饰和调味。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "black-habanero": {
    "name": "黑色哈瓦那辣椒",
    "description": "黑色哈瓦那辣椒是茄科植物，是哈瓦那辣椒的变种。果实成熟时呈黑褐色，辣度极高，带有独特的果香和烟熏味。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "black-prince-tomato": {
    "name": "黑王子番茄",
    "description": "黑王子番茄是茄科植物，是古老番茄品种。果实深紫红色，肉质丰厚，口感浓郁甜美，富含番茄红素。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "black-salsify": {
    "name": "黑婆罗门参",
    "description": "黑婆罗门参是菊科植物，原产于欧洲。根部黑色细长，口感类似牡蛎，富含膳食纤维和矿物质，是特色蔬菜。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "blackberry": {
    "name": "黑莓",
    "description": "黑莓是蔷薇科灌木，原产于北美洲。果实黑色多汁，富含花青素、维生素C和膳食纤维，具有抗氧化功效。",
    "sun_requirements": "全日照",
    "sowing_method": "育苗移栽"
  },
  "blue-lake-bean": {
    "name": "蓝湖豆",
    "description": "蓝湖豆是豆科植物，是著名的四季豆品种。豆荚翠绿，口感脆嫩，无纤维，富含蛋白质和维生素C。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "blue-oyster-mushroom": {
    "name": "蓝平菇",
    "description": "蓝平菇是侧耳科真菌，原产于亚洲。菌盖呈蓝灰色，质地嫩滑，富含蛋白质和膳食纤维，是重要的食用菌。",
    "sun_requirements": "半阴",
    "sowing_method": "菌丝培养"
  },
  "blueberry": {
    "name": "蓝莓",
    "description": "蓝莓是杜鹃花科多年生灌木，原产于北美洲。果实蓝色小巧，富含花青素和维生素C，具有抗氧化、保护视力的功效。",
    "sun_requirements": "全日照",
    "sowing_method": "育苗移栽"
  },
  "bok-choy": {
    "name": "小白菜",
    "description": "小白菜是十字花科植物，原产于中国。叶片翠绿鲜嫩，茎部白色脆嫩，富含维生素C、钙和纤维，是亚洲常见蔬菜。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "borage": {
    "name": "琉璃苣",
    "description": "琉璃苣是紫草科植物，原产于地中海地区。叶片和花朵皆可食用，带有淡淡的黄瓜香味，富含γ-亚麻酸，常用于装饰沙拉。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "brazilian-starfish-pepper": {
    "name": "巴西海星辣椒",
    "description": "巴西海星辣椒是茄科植物，原产于巴西。果实扁平星形，辣度中等，带有独特的果香和热带水果风味。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "broccoli": {
    "name": "西兰花",
    "description": "西兰花是十字花科植物，原产于意大利。花蕾密集翠绿，营养丰富，富含维生素C、K和膳食纤维，被誉为'蔬菜皇冠'。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "brussels-sprout": {
    "name": "球芽甘蓝",
    "description": "球芽甘蓝是十字花科植物，原产于比利时。茎干上长满小球状芽，口感脆嫩微苦，富含维生素C、K和膳食纤维。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "butternut-squash": {
    "name": "奶油南瓜",
    "description": "奶油南瓜是葫芦科植物，原产于美国。果实梨形，果皮浅黄橙色，果肉香甜软糯，富含维生素A和β-胡萝卜素。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "california-poppy": {
    "name": "加州罂粟",
    "description": "加州罂粟是罂粟科植物，原产于美国西部。花朵橙色鲜艳，具有观赏价值，也是加州州花。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "cannabis": {
    "name": "大麻",
    "description": "大麻是桑科植物，原产于中亚。纤维可用于纺织，种子富含蛋白质和健康脂肪，在许多地区受法律管制。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "cantaloupe": {
    "name": "哈密瓜",
    "description": "哈密瓜是葫芦科植物，原产于亚洲。果实圆形，果皮网纹，果肉橙色香甜，水分丰富，富含维生素A和C。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "carrot": {
    "name": "胡萝卜",
    "description": "胡萝卜是伞形科二年生草本植物，原产于欧洲。根部为橙红色圆锥形，富含胡萝卜素和维生素，是重要的根茎类蔬菜。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "cascabel-chili": {
    "name": "响板辣椒",
    "description": "响板辣椒是茄科植物，原产于墨西哥。果实干燥后摇动有响声，辣度中等，带有坚果和烟熏风味，常用于墨西哥料理。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "cauliflower": {
    "name": "花椰菜",
    "description": "花椰菜是十字花科植物，原产于地中海地区。花蕾洁白紧密，质地细腻，富含维生素C、K和叶酸，营养密度极高。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "cayenne-pepper": {
    "name": "卡宴辣椒",
    "description": "卡宴辣椒是茄科植物，原产于法属圭亚那。果实细长，辣度高，常干燥后磨成辣椒粉，广泛用于调味。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "celeriac-root": {
    "name": "根芹",
    "description": "根芹是伞形科植物，是芹菜的变种。根部球状，质地细腻，带有芹菜的香气，富含维生素K和矿物质。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "celery": {
    "name": "芹菜",
    "description": "芹菜是伞形科植物，原产于地中海地区。茎秆翠绿脆嫩，富含膳食纤维、维生素K和矿物质，具有降血压的功效。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "chamomile": {
    "name": "洋甘菊",
    "description": "洋甘菊是菊科一年生草本植物，原产于欧洲。花朵白色，香气淡雅，富含精油，具有镇静安神、助消化等功效。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "chantrelle-mushroom": {
    "name": "鸡油菌",
    "description": "鸡油菌是鸡油菌科真菌，原产于北半球。菌盖金黄色，呈漏斗形，质地嫩滑，带有水果香气，是珍贵的食用菌。",
    "sun_requirements": "半阴",
    "sowing_method": "菌丝培养或野生采集"
  },
  "cheongyang-pepper": {
    "name": "清阳辣椒",
    "description": "清阳辣椒是茄科植物，原产于韩国。果实绿色长条形，辣度中等，带有独特的清香，是韩国料理的重要调味菜。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "cherokee-purple-tomato": {
    "name": "切罗基紫番茄",
    "description": "切罗基紫番茄是茄科植物，是古老番茄品种。果实紫红色带绿色肩部，肉质丰厚，口感浓郁甜美，富含番茄红素。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "cherry-belle-radish": {
    "name": "樱桃红萝卜",
    "description": "樱桃红萝卜是十字花科植物，是常见的萝卜品种。根部小型鲜红，口感脆嫩微辣，富含维生素C和消化酶。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "cherry-stuffer-pepper": {
    "name": "樱桃塞馅辣椒",
    "description": "樱桃塞馅辣椒是茄科植物。果实圆形较大，果肉厚实，辣度低，适合塞馅填充，是开胃菜的理想选择。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "cherry-tomato": {
    "name": "樱桃番茄",
    "description": "樱桃番茄是茄科植物，原产于南美洲。果实小型圆形，红色或黄色，口感甜美多汁，富含番茄红素和维生素C。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "chile-de-aborol-pepper": {
    "name": "阿博罗辣椒",
    "description": "阿博罗辣椒是茄科植物，原产于墨西哥。果实大型，辣度中等，常用于制作辣酱和干制。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "cilantro": {
    "name": "香菜",
    "description": "香菜是伞形科一年生草本植物，原产于地中海地区。叶片清香，富含维生素A、C和K，是亚洲和中东料理的重要配菜。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "cinnamon-cap-mushroom": {
    "name": "肉桂平菇",
    "description": "肉桂平菇是侧耳科真菌。菌盖呈肉桂色，质地嫩滑，富含蛋白质和膳食纤维，是特色食用菌。",
    "sun_requirements": "半阴",
    "sowing_method": "菌丝培养"
  },
  "claytonia": {
    "name": "克莱通尼草",
    "description": "克莱通尼草是石竹科植物，原产于北美洲。叶片肉质嫩滑，口感温和，富含维生素C，常用于沙拉。",
    "sun_requirements": "半阴到全日照",
    "sowing_method": "直接播种"
  },
  "collard-greens": {
    "name": "羽衣甘蓝",
    "description": "羽衣甘蓝是十字花科植物，原产于地中海地区。叶片深绿皱褶，富含维生素A、C、K和抗氧化物质，被誉为'超级蔬菜'。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "corn": {
    "name": "玉米",
    "description": "玉米是禾本科植物，原产于中美洲。颗粒金黄饱满，富含碳水化合物、蛋白质和维生素，是世界主要粮食作物之一。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "cotton": {
    "name": "棉花",
    "description": "棉花是锦葵科植物，原产于亚洲。棉纤维用于纺织，种子可榨油，是全球最重要的经济作物之一。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "cremini-mushroom": {
    "name": "克里米尼蘑菇",
    "description": "克里米尼蘑菇是蘑菇科真菌，是双孢菇的变种。菌盖浅褐色，质地嫩滑，富含蛋白质和硒，是常见食用菌。",
    "sun_requirements": "半阴",
    "sowing_method": "菌丝培养"
  },
  "cubanelle-pepper": {
    "name": "古巴内拉辣椒",
    "description": "古巴内拉辣椒是茄科植物，原产于古巴。果实长而扁平，辣度极低，果肉厚实，常用于意大利菜。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "cucumber": {
    "name": "黄瓜",
    "description": "黄瓜是葫芦科植物，原产于印度。果实为绿色长条形，水分含量高达95%以上，口感清爽，是夏季消暑的理想蔬菜。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "curly-endive": {
    "name": "卷叶苦苣",
    "description": "卷叶苦苣是菊科植物，原产于欧洲。叶片紧密卷曲，口感微苦脆嫩，富含维生素K和叶酸，常用于沙拉。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种或育苗移栽"
  },
  "curly-kale": {
    "name": "卷叶羽衣甘蓝",
    "description": "卷叶羽衣甘蓝是十字花科植物，原产于地中海地区。叶片深绿卷曲，富含维生素A、C、K和抗氧化物质，是营养密度极高的蔬菜。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "dandelion": {
    "name": "蒲公英",
    "description": "蒲公英是菊科植物，原产于欧洲。叶片、花朵和根部皆可食用，富含维生素和矿物质，具有利尿和保肝功效。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "dark-opal-basil": {
    "name": "深紫罗勒",
    "description": "深紫罗勒是唇形科植物，是罗勒的紫色变种。叶片深紫色，香气浓郁，富含花青素和维生素K，常用于装饰沙拉。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "datil-pepper": {
    "name": "达提尔辣椒",
    "description": "达提尔辣椒是茄科植物，原产于佛罗里达州。果实小型，辣度极高，带有独特的热带水果风味，是当地特色辣椒。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "delicata-squash": {
    "name": "精致南瓜",
    "description": "精致南瓜是葫芦科植物，原产于美国。果实小型椭圆形，果皮带条纹，果肉香甜软糯，富含维生素A和β-胡萝卜素。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "diablito-pepper": {
    "name": "迪亚布利托辣椒",
    "description": "迪亚布利托辣椒是茄科植物，原产于墨西哥。果实小型，辣度较高，带有独特的果香和烟熏味。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "dill": {
    "name": "莳萝",
    "description": "莳萝是伞形科一年生草本植物，原产于地中海地区。叶片和种子香气独特，富含抗氧化物质，常用于腌制和调味。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "dundicut-pepper": {
    "name": "顿迪库特辣椒",
    "description": "顿迪库特辣椒是茄科植物，原产于巴基斯坦。果实小型，辣度高，常用于制作当地特色辣酱。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "echinacea": {
    "name": "紫锥菊",
    "description": "紫锥菊是菊科多年生草本植物，原产于北美洲。花朵紫色美丽，具有增强免疫力、抗炎等保健功效。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "eggplant": {
    "name": "茄子",
    "description": "茄子是茄科一年生或多年生草本植物，原产于印度。果实呈紫黑色或白色，富含维生素和矿物质，口感软嫩，是常见的烹饪食材。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "facing-heaven-pepper": {
    "name": "朝天椒",
    "description": "朝天椒是茄科植物，原产于中国。果实向上生长，辣度极高，常用于调味和制作辣椒酱。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "fatilii-pepper": {
    "name": "法蒂利辣椒",
    "description": "法蒂利辣椒是茄科植物，原产于泰国。果实弯曲长条形，辣度极高，带有独特的柑橘香气，广泛用于泰国料理。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "fava-bean": {
    "name": "蚕豆",
    "description": "蚕豆是豆科植物，原产于地中海地区。豆荚大型，豆粒饱满，富含蛋白质和膳食纤维，口感香甜。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "fennel": {
    "name": "茴香",
    "description": "茴香是伞形科多年生草本植物，原产于地中海地区。叶片和球茎皆可食用，带有独特的茴香香气，富含抗氧化物质。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "flower": {
    "name": "花卉",
    "description": "花卉是各种开花植物的统称，具有观赏价值，可美化环境，部分花朵也可食用。",
    "sun_requirements": "全日照",
    "sowing_method": "播种育苗"
  },
  "french-breakfast-radish": {
    "name": "法式早餐萝卜",
    "description": "法式早餐萝卜是十字花科植物，原产于法国。根部白色带红色尖端，口感脆嫩微甜，富含维生素C。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "fresno-pepper": {
    "name": "弗雷斯诺辣椒",
    "description": "弗雷斯诺辣椒是茄科植物，原产于加利福尼亚州。果实细长，辣度中等，常用于墨西哥菜和辣酱制作。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "fuji-apple": {
    "name": "富士苹果",
    "description": "富士苹果是蔷薇科乔木，原产于日本。果实大型红色，口感脆甜多汁，富含维生素C和抗氧化物质，是世界主要苹果品种之一。",
    "sun_requirements": "全日照",
    "sowing_method": "嫁接育苗"
  },
  "gala-apple": {
    "name": "嘎啦苹果",
    "description": "嘎啦苹果是蔷薇科乔木，原产于新西兰。果实中小型，红黄相间，口感香甜脆嫩，富含维生素C。",
    "sun_requirements": "全日照",
    "sowing_method": "嫁接育苗"
  },
  "galangal": {
    "name": "高良姜",
    "description": "高良姜是姜科植物，原产于东南亚。根部带有浓郁的柑橘和松香气味，富含姜黄素，广泛用于东南亚料理。",
    "sun_requirements": "半阴到全日照",
    "sowing_method": "种植根茎"
  },
  "garlic": {
    "name": "大蒜",
    "description": "大蒜是百合科植物，原产于中亚。鳞茎由多个蒜瓣组成，富含大蒜素和硫化物，具有抗菌、抗氧化等多种保健功效。",
    "sun_requirements": "全日照",
    "sowing_method": "种植蒜瓣"
  },
  "garlic-chives": {
    "name": "蒜苗",
    "description": "蒜苗是百合科植物，是大蒜的幼苗。叶片扁平，带有浓郁的大蒜香气，富含维生素C和硫化物，常用于炒菜。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "种植蒜瓣"
  },
  "generic-plant": {
    "name": "通用植物",
    "description": "通用植物模板，用于未分类或自定义的植物。",
    "sun_requirements": "全日照",
    "sowing_method": "根据植物特性选择"
  },
  "german-chamomile": {
    "name": "德国洋甘菊",
    "description": "德国洋甘菊是菊科一年生草本植物，原产于欧洲。花朵白色，香气淡雅，富含精油，具有镇静安神功效。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "ghost-pepper": {
    "name": "鬼椒",
    "description": "鬼椒是茄科植物，原产于印度。果实红色，辣度极高，曾是世界最辣辣椒之一，带有独特的果香和烟熏味。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "ginger": {
    "name": "生姜",
    "description": "生姜是姜科植物，原产于东南亚。根部辛辣芳香，富含姜辣素和抗氧化物质，具有驱寒、助消化等功效。",
    "sun_requirements": "半阴到全日照",
    "sowing_method": "种植根茎"
  },
  "golden-beet": {
    "name": "金色甜菜",
    "description": "金色甜菜是苋科植物，是甜菜的黄色品种。根部金黄色，质地甜嫩，富含甜菜红素和叶酸。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "golden-delicious-apple": {
    "name": "金冠苹果",
    "description": "金冠苹果是蔷薇科乔木，原产于美国。果实金黄色，口感香甜多汁，富含维生素C，是世界主要苹果品种之一。",
    "sun_requirements": "全日照",
    "sowing_method": "嫁接育苗"
  },
  "granny-smith-apple": {
    "name": "青苹果",
    "description": "青苹果是蔷薇科乔木，原产于澳大利亚。果实绿色，口感酸脆，富含维生素C和膳食纤维，适合烹饪和生食。",
    "sun_requirements": "全日照",
    "sowing_method": "嫁接育苗"
  },
  "green-anjou-pear": {
    "name": "绿安茹梨",
    "description": "绿安茹梨是蔷薇科乔木，原产于法国。果实绿色，果肉多汁甜润，富含膳食纤维和维生素C。",
    "sun_requirements": "全日照",
    "sowing_method": "嫁接育苗"
  },
  "green-bartlett-pear": {
    "name": "绿巴特利特梨",
    "description": "绿巴特利特梨是蔷薇科乔木，原产于英国。果实绿色，果肉香甜多汁，富含膳食纤维和维生素C。",
    "sun_requirements": "全日照",
    "sowing_method": "嫁接育苗"
  },
  "green-bell-pepper": {
    "name": "青椒",
    "description": "青椒是茄科植物，是甜椒的绿色品种。果实大型，辣度低，果肉厚实，富含维生素C和胡萝卜素。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "green-birds-eye-chili": {
    "name": "绿鸟眼辣椒",
    "description": "绿鸟眼辣椒是茄科植物，是鸟眼辣椒的未成熟品种。果实绿色小型，辣度极高，带有柑橘香气。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "green-cabbage": {
    "name": "绿卷心菜",
    "description": "绿卷心菜是十字花科植物，原产于欧洲。叶片紧密包裹成球状，质地脆嫩，富含维生素C和膳食纤维。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "green-onion": {
    "name": "青葱",
    "description": "青葱是百合科植物，是葱的品种之一。茎叶皆可食用，带有浓郁的葱香，富含维生素C和硫化物，广泛用于调味。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "green-serrano-pepper": {
    "name": "绿塞拉诺辣椒",
    "description": "绿塞拉诺辣椒是茄科植物，是塞拉诺辣椒的未成熟品种。果实绿色，辣度中高，常用于墨西哥料理。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "green-tabasco-pepper": {
    "name": "绿塔巴斯克辣椒",
    "description": "绿塔巴斯克辣椒是茄科植物，是塔巴斯克辣椒的未成熟品种。果实绿色，辣度中高，用于制作塔巴斯克辣酱。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "green-zebra-tomato": {
    "name": "绿斑马番茄",
    "description": "绿斑马番茄是茄科植物，是特色番茄品种。果实黄色带绿色条纹，口感酸甜独特，富含番茄红素。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "guajillo-pepper": {
    "name": "瓜希略辣椒",
    "description": "瓜希略辣椒是茄科植物，原产于墨西哥。果实干燥后呈深红色，辣度中等，带有独特的葡萄干和茶香气，常用于制作酱料。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "habanero-pepper": {
    "name": "哈瓦那辣椒",
    "description": "哈瓦那辣椒是茄科植物，原产于古巴。果实小型灯笼状，辣度极高，带有独特的热带水果香气，是世界最辣辣椒之一。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "hemp": {
    "name": "大麻纤维",
    "description": "大麻是桑科植物，原产于中亚。纤维强韧，用于纺织、造纸等，种子富含蛋白质和健康脂肪。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "hillbilly-tomato": {
    "name": "山民番茄",
    "description": "山民番茄是茄科植物，是古老番茄品种。果实大型，红黄相间，肉质丰厚，口感浓郁甜美。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "honeydew-melon": {
    "name": "甜瓜",
    "description": "甜瓜是葫芦科植物，原产于西亚。果实圆形，果皮浅黄绿色，果肉清甜多汁，富含维生素C和钾。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "hop": {
    "name": "啤酒花",
    "description": "啤酒花是大麻科植物，原产于欧洲。花朵用于啤酒酿造，提供苦味和香气，也具有镇静安神功效。",
    "sun_requirements": "全日照",
    "sowing_method": "种植根茎"
  },
  "hungarian-wax-pepper": {
    "name": "匈牙利蜡辣椒",
    "description": "匈牙利蜡辣椒是茄科植物，原产于匈牙利。果实黄色蜡状，辣度中低，果肉厚实，常用于匈牙利料理。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "iceberg-lettuce": {
    "name": "冰山生菜",
    "description": "冰山生菜是菊科植物，原产于美国。叶片紧密包裹成球状，质地脆嫩，水分含量高，富含维生素A和K，是常见沙拉蔬菜。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种或育苗移栽"
  },
  "icicle-radish": {
    "name": "冰柱萝卜",
    "description": "冰柱萝卜是十字花科植物，原产于东亚。根部细长白色如冰柱，口感脆嫩微辣，富含维生素C。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "indigo": {
    "name": "靛蓝",
    "description": "靛蓝是豆科植物，原产于印度。叶片可提取靛蓝染料，用于纺织染色，是传统天然染料来源之一。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "jalapeno": {
    "name": "哈拉佩诺辣椒",
    "description": "哈拉佩诺辣椒是茄科植物，原产于墨西哥。果实绿色或红色，辣度中高，带有独特的烟熏香气，广泛用于墨西哥料理。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "japanese-yam": {
    "name": "日本山药",
    "description": "日本山药是薯蓣科植物，原产于东亚。根部长圆柱形，质地黏滑，富含黏液蛋白和淀粉，口感清淡。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "种植块茎"
  },
  "kabocha-squash": {
    "name": "日式南瓜",
    "description": "日式南瓜是葫芦科植物，原产于日本。果实小型深绿色，果肉橙色香甜软糯，富含维生素A和β-胡萝卜素。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "kohlrabi": {
    "name": "球茎甘蓝",
    "description": "球茎甘蓝是十字花科植物，原产于欧洲。茎部膨大成球状，口感脆嫩，富含维生素C、K和膳食纤维。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "lacinato-kale": {
    "name": "托斯卡纳羽衣甘蓝",
    "description": "托斯卡纳羽衣甘蓝是十字花科植物，原产于意大利。叶片深绿狭长如棕榈叶，富含维生素A、C、K和抗氧化物质。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "lavender": {
    "name": "薰衣草",
    "description": "薰衣草是唇形科多年生灌木，原产于地中海地区。花朵紫色，香气浓郁，富含精油，具有镇静、抗菌和驱虫等功效。",
    "sun_requirements": "全日照",
    "sowing_method": "育苗移栽"
  },
  "leek": {
    "name": "韭葱",
    "description": "韭葱是百合科植物，原产于地中海地区。茎部粗壮类似大蒜，带有温和的洋葱香气，富含维生素K和膳食纤维。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "lemon-balm": {
    "name": "柠檬香蜂草",
    "description": "柠檬香蜂草是唇形科多年生草本植物，原产于欧洲。叶片带有柠檬香气，富含抗氧化物质，具有镇静安神功效。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "育苗移栽或播种"
  },
  "lemon-drop-pepper": {
    "name": "柠檬滴辣椒",
    "description": "柠檬滴辣椒是茄科植物，原产于秘鲁。果实黄色，辣度极高，带有浓郁的柠檬香气，是特色辣椒。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "lemon-verbena": {
    "name": "柠檬马鞭草",
    "description": "柠檬马鞭草是马鞭草科植物，原产于南美洲。叶片带有浓郁的柠檬香气，富含抗氧化物质，用于茶饮和烹饪。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "育苗移栽"
  },
  "lemongrass": {
    "name": "柠檬草",
    "description": "柠檬草是禾本科植物，原产于东南亚。茎杆带有浓郁的柠檬香气，富含抗氧化物质，广泛用于东南亚料理。",
    "sun_requirements": "全日照",
    "sowing_method": "分株或播种育苗"
  },
  "lima-bean": {
    "name": "利马豆",
    "description": "利马豆是豆科植物，原产于南美洲。豆荚扁平，豆粒绿色或奶油色，富含蛋白质和膳食纤维。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "lions-mane-mushroom": {
    "name": "狮子鬃毛蘑菇",
    "description": "狮子鬃毛蘑菇是齿菌科真菌，原产于北半球。菌盖白色如狮鬃，质地嫩滑，富含蛋白质和神经生长因子，具有健脑功效。",
    "sun_requirements": "半阴",
    "sowing_method": "菌丝培养"
  },
  "looseleaf-lettuce": {
    "name": "散叶生菜",
    "description": "散叶生菜是菊科植物，叶片松散不卷曲，质地柔软，富含维生素A和K，口感清香。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种或育苗移栽"
  },
  "lovage": {
    "name": "独活草",
    "description": "独活草是伞形科多年生草本植物，原产于欧洲。叶片和种子带有浓郁的芹菜香气，富含维生素K和矿物质。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "育苗移栽或播种"
  },
  "madame-jeanette-pepper": {
    "name": "珍妮特夫人辣椒",
    "description": "珍妮特夫人辣椒是茄科植物，原产于苏里南。果实黄色，辣度极高，带有独特的果香和花香。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "malagueta-pepper": {
    "name": "马拉盖塔辣椒",
    "description": "马拉盖塔辣椒是茄科植物，原产于巴西。果实小型，辣度极高，是巴西料理的重要调味料。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "marjoram": {
    "name": "马郁兰",
    "description": "马郁兰是唇形科多年生草本植物，原产于地中海地区。叶片香气温和甜美，富含抗氧化物质，常用于西式料理。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "marshmallow": {
    "name": "药蜀葵",
    "description": "药蜀葵是锦葵科多年生草本植物，原产于欧洲。根叶富含黏液质，具有润喉、止咳功效，是传统药用植物。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "medusa-pepper": {
    "name": "美杜莎辣椒",
    "description": "美杜莎辣椒是茄科植物。果实细长卷曲如蛇发，辣度低，果肉厚实，适合塞馅，具有观赏价值。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "melon": {
    "name": "甜瓜",
    "description": "甜瓜是葫芦科植物，原产于亚洲。果实圆形或椭圆形，果皮光滑或网纹，果肉清甜多汁，富含维生素C。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "millet": {
    "name": "小米",
    "description": "小米是禾本科植物，原产于东亚。颗粒小型，富含蛋白质、膳食纤维和矿物质，是世界主要粮食作物之一。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "mint": {
    "name": "薄荷",
    "description": "薄荷是唇形科多年生草本植物，原产于欧洲和亚洲。叶片清凉芳香，富含薄荷醇和抗氧化物质，广泛用于茶饮、甜品和调味。",
    "sun_requirements": "半阴到全日照",
    "sowing_method": "分株或播种育苗"
  },
  "money-tree": {
    "name": "发财树",
    "description": "发财树是锦葵科植物，原产于中美洲。茎干粗壮，叶片掌状分裂，具有观赏价值，是常见的室内植物。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "播种育苗"
  },
  "mugwort": {
    "name": "艾草",
    "description": "艾草是菊科多年生草本植物，原产于亚洲。叶片芳香，富含挥发油，具有驱寒、祛湿等功效，广泛用于中医。",
    "sun_requirements": "全日照",
    "sowing_method": "育苗移栽或播种"
  },
  "mushroom": {
    "name": "蘑菇",
    "description": "蘑菇是大型真菌的统称，菌盖肉质嫩滑，富含蛋白质、膳食纤维和抗氧化物质，是重要的食用菌。",
    "sun_requirements": "半阴",
    "sowing_method": "菌丝培养"
  },
  "napa-cabbage": {
    "name": "大白菜",
    "description": "大白菜是十字花科植物，原产于中国。叶片层层包裹成球状，质地脆嫩，富含维生素C和纤维，是亚洲冬季主要蔬菜。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "nectarine": {
    "name": "油桃",
    "description": "油桃是蔷薇科乔木，原产于中国。果实光滑无毛，果肉多汁香甜，富含维生素A和C，口感清爽。",
    "sun_requirements": "全日照",
    "sowing_method": "嫁接育苗"
  },
  "oat": {
    "name": "燕麦",
    "description": "燕麦是禾本科植物，原产于西亚。颗粒富含膳食纤维、蛋白质和β-葡聚糖，是健康的谷物选择。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "okra": {
    "name": "秋葵",
    "description": "秋葵是锦葵科植物，原产于非洲。果实细长绿色，富含黏液质、膳食纤维和维生素，口感独特。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "onion-chive": {
    "name": "细香葱",
    "description": "细香葱是百合科植物，是葱的品种之一。茎叶细长，带有温和的葱香，富含维生素C，广泛用于调味和装饰。",
    "sun_requirements": "全日照",
    "sowing_method": "分株或播种"
  },
  "orange-bell-pepper": {
    "name": "橙甜椒",
    "description": "橙甜椒是茄科植物，是甜椒的橙色品种。果实大型，辣度低，果肉厚实，富含维生素C和胡萝卜素。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "orange-scotch-bonnet": {
    "name": "橙苏格兰圆帽辣椒",
    "description": "橙苏格兰圆帽辣椒是茄科植物，是苏格兰圆帽辣椒的橙色品种。果实扁圆形，辣度极高，带有果香。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "oregano": {
    "name": "牛至",
    "description": "牛至是唇形科多年生草本植物，原产于地中海地区。叶片香气独特，富含抗氧化物质，是意大利菜和披萨的常用香料。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "ornamental-gourd": {
    "name": "观赏葫芦",
    "description": "观赏葫芦是葫芦科植物，果实形态各异，颜色鲜艳，具有观赏价值，广泛用于装饰。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "parsley": {
    "name": "欧芹",
    "description": "欧芹是伞形科二年生草本植物，原产于地中海地区。叶片翠绿，富含维生素K、C和抗氧化物质，广泛用于西式料理装饰和调味。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "parsnip": {
    "name": "防风草",
    "description": "防风草是伞形科二年生草本植物，原产于欧洲。根部浅黄色，质地甜嫩，富含钾和膳食纤维，有独特的香料味。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "pattypan-squash": {
    "name": "扁圆南瓜",
    "description": "扁圆南瓜是葫芦科植物，原产于北美洲。果实扁圆形，边缘波浪状，果皮黄色或绿色，果肉嫩滑。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "peach": {
    "name": "桃子",
    "description": "桃子是蔷薇科乔木，原产于中国。果实圆形，果皮绒毛，果肉黄色或白色多汁香甜，富含维生素A和C。",
    "sun_requirements": "全日照",
    "sowing_method": "嫁接育苗"
  },
  "peanut": {
    "name": "花生",
    "description": "花生是豆科植物，原产于南美洲。果实地下生长，富含蛋白质、健康脂肪和维生素E，是世界重要油料作物。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "peppadew-pepper": {
    "name": "佩帕德温辣椒",
    "description": "佩帕德温辣椒是茄科植物，原产于南非。果实红色圆形，辣度低，果肉甜嫩，常用于填充奶酪或橄榄。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "pequin-pepper": {
    "name": "佩金辣椒",
    "description": "佩金辣椒是茄科植物，原产于墨西哥。果实小型，辣度极高，带有独特的烟熏和坚果香气。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "peter-pepper": {
    "name": "彼得辣椒",
    "description": "彼得辣椒是茄科植物，因果实形状独特而闻名。果实红色，辣度中高，具有观赏价值。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "pimento-pepper": {
    "name": "皮门托辣椒",
    "description": "皮门托辣椒是茄科植物，果实大型心形，辣度低，果肉厚实甜嫩，常用于填充和制作辣椒酱。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "pineapple-tomato": {
    "name": "菠萝番茄",
    "description": "菠萝番茄是茄科植物，是特色番茄品种。果实大型黄色，带有独特的菠萝香气，口感酸甜。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "pink-oyster-mushroom": {
    "name": "粉红平菇",
    "description": "粉红平菇是侧耳科真菌，原产于亚洲。菌盖粉红色如贝壳，质地嫩滑，富含蛋白质和膳食纤维。",
    "sun_requirements": "半阴",
    "sowing_method": "菌丝培养"
  },
  "plantain": {
    "name": "大蕉",
    "description": "大蕉是芭蕉科植物，原产于东南亚。果实大型，皮厚肉实，富含淀粉和钾，需烹饪后食用，是热带地区主要食物来源。",
    "sun_requirements": "全日照",
    "sowing_method": "分株育苗"
  },
  "plum": {
    "name": "李子",
    "description": "李子是蔷薇科乔木，原产于中国。果实圆形或椭圆形，果皮紫色或黄色，果肉多汁香甜，富含维生素和矿物质。",
    "sun_requirements": "全日照",
    "sowing_method": "嫁接育苗"
  },
  "poblano-pepper": {
    "name": "波布拉诺辣椒",
    "description": "波布拉诺辣椒是茄科植物，原产于墨西哥。果实大型深绿色，辣度中低，果肉厚实，常用于制作辣椒酱或酿制。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "pointed-cabbage": {
    "name": "尖头卷心菜",
    "description": "尖头卷心菜是十字花科植物，原产于欧洲。叶片紧密包裹成圆锥形，质地脆嫩，富含维生素C和膳食纤维。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "porcini-mushroom": {
    "name": "牛肝菌",
    "description": "牛肝菌是牛肝菌科真菌，原产于欧洲。菌盖褐色，质地嫩滑，带有浓郁的坚果香气，是珍贵的食用菌。",
    "sun_requirements": "半阴",
    "sowing_method": "菌丝培养或野生采集"
  },
  "portabello-mushroom": {
    "name": "波塔贝罗蘑菇",
    "description": "波塔贝罗蘑菇是蘑菇科真菌，是成熟的双孢菇。菌盖大型褐色，质地嫩滑，富含蛋白质和硒，是常见食用菌。",
    "sun_requirements": "半阴",
    "sowing_method": "菌丝培养"
  },
  "psilocybin-mushroom": {
    "name": "裸盖菇",
    "description": "裸盖菇是裸盖菇科真菌，原产于热带地区。含有裸盖菇素，具有致幻作用，在许多地区受法律管制。",
    "sun_requirements": "半阴",
    "sowing_method": "菌丝培养"
  },
  "pumpkin": {
    "name": "南瓜",
    "description": "南瓜是葫芦科植物，原产于美洲。果实大型，果肉橙色甜糯，富含胡萝卜素、维生素A和C，是重要的秋冬季蔬菜。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "purple-carrot": {
    "name": "紫胡萝卜",
    "description": "紫胡萝卜是伞形科植物，是胡萝卜的紫色品种。根部深紫色，富含花青素和胡萝卜素，营养价值极高。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "purple-cauliflower": {
    "name": "紫花椰菜",
    "description": "紫花椰菜是十字花科植物，是花椰菜的紫色品种。花蕾紫色紧密，富含花青素和维生素C，营养密度极高。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "purple-pod-bean": {
    "name": "紫荚豆",
    "description": "紫荚豆是豆科植物，豆荚呈紫色，口感脆嫩，富含花青素和膳食纤维，成熟后变绿。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "purple-potato": {
    "name": "紫土豆",
    "description": "紫土豆是茄科植物，是土豆的紫色品种。块茎深紫色，富含花青素、淀粉和维生素C，营养丰富。",
    "sun_requirements": "全日照",
    "sowing_method": "种植块茎或种薯"
  },
  "radicchio": {
    "name": "红菊苣",
    "description": "红菊苣是菊科植物，原产于意大利。叶片紫红色，包裹紧密，口感微苦脆嫩，富含花青素和维生素K。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种或育苗移栽"
  },
  "rainbow-chard": {
    "name": "彩虹瑞士甜菜",
    "description": "彩虹瑞士甜菜是苋科植物，叶柄呈红、黄、橙等多种颜色，质地脆嫩，富含维生素K和矿物质。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "rainier-cherry": {
    "name": "雷尼尔樱桃",
    "description": "雷尼尔樱桃是蔷薇科乔木，原产于美国。果实黄红色，果肉甜美多汁，富含抗氧化物质和维生素C。",
    "sun_requirements": "全日照",
    "sowing_method": "嫁接育苗"
  },
  "raspberry": {
    "name": "覆盆子",
    "description": "覆盆子是蔷薇科灌木，原产于北美洲。果实红色多汁，富含花青素、维生素C和膳食纤维，具有抗氧化功效。",
    "sun_requirements": "全日照",
    "sowing_method": "育苗移栽"
  },
  "red-anjou-pear": {
    "name": "红安茹梨",
    "description": "红安茹梨是蔷薇科乔木，原产于法国。果实红绿色，果肉多汁甜润，富含膳食纤维和维生素C。",
    "sun_requirements": "全日照",
    "sowing_method": "嫁接育苗"
  },
  "red-bartlett-pear": {
    "name": "红巴特利特梨",
    "description": "红巴特利特梨是蔷薇科乔木，原产于英国。果实红色，果肉香甜多汁，富含膳食纤维和维生素C。",
    "sun_requirements": "全日照",
    "sowing_method": "嫁接育苗"
  },
  "red-bell-pepper": {
    "name": "红椒",
    "description": "红椒是茄科植物，是甜椒的红色品种。果实大型，辣度低，果肉厚实，富含维生素C和胡萝卜素。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "red-cabbage": {
    "name": "红卷心菜",
    "description": "红卷心菜是十字花科植物，原产于欧洲。叶片紧密包裹成球状，紫红色，质地脆嫩，富含花青素和维生素C。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "red-carrot": {
    "name": "红胡萝卜",
    "description": "红胡萝卜是伞形科植物，是胡萝卜的红色品种。根部深红色，富含番茄红素和胡萝卜素，营养价值极高。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "red-chard": {
    "name": "红瑞士甜菜",
    "description": "红瑞士甜菜是苋科植物，叶柄红色，叶片深绿色，质地脆嫩，富含维生素K和矿物质。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "red-curly-kale": {
    "name": "红卷叶羽衣甘蓝",
    "description": "红卷叶羽衣甘蓝是十字花科植物，原产于地中海地区。叶片紫红色卷曲，富含花青素、维生素和抗氧化物质。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "red-giant-mustard": {
    "name": "红巨芥菜",
    "description": "红巨芥菜是十字花科植物，叶片大型紫红色，口感辛辣，富含维生素和矿物质，常用于亚洲料理。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "red-gold-potato": {
    "name": "红金土豆",
    "description": "红金土豆是茄科植物，块茎外皮红色，果肉金黄色，富含淀粉、维生素C和钾，口感香甜。",
    "sun_requirements": "全日照",
    "sowing_method": "种植块茎或种薯"
  },
  "red-kuri-squash": {
    "name": "红栗南瓜",
    "description": "红栗南瓜是葫芦科植物，原产于日本。果实小型橙色，果肉香甜软糯，富含维生素A和β-胡萝卜素。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "red-onion": {
    "name": "红洋葱",
    "description": "红洋葱是百合科植物，鳞茎紫红色，带有温和的辛辣味，富含硫化物和花青素，常用于生食和烹饪。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "red-pointed-cabbage": {
    "name": "红尖头卷心菜",
    "description": "红尖头卷心菜是十字花科植物，叶片紧密包裹成紫红色圆锥形，质地脆嫩，富含花青素和维生素C。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "red-russian-kale": {
    "name": "红俄罗斯羽衣甘蓝",
    "description": "红俄罗斯羽衣甘蓝是十字花科植物，叶片紫红色锯齿形，质地柔软，富含花青素、维生素和抗氧化物质。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "red-savina-pepper": {
    "name": "红萨维纳辣椒",
    "description": "红萨维纳辣椒是茄科植物，是哈瓦那辣椒的变种。果实红色，辣度极高，曾是世界最辣辣椒之一。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "red-scotch-bonnet": {
    "name": "红苏格兰圆帽辣椒",
    "description": "红苏格兰圆帽辣椒是茄科植物，果实扁圆形深红色，辣度极高，带有独特的果香和花香。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "red-serrano-pepper": {
    "name": "红塞拉诺辣椒",
    "description": "红塞拉诺辣椒是茄科植物，是塞拉诺辣椒的成熟品种。果实红色，辣度中高，常用于墨西哥料理。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "red-tabasco-pepper": {
    "name": "红塔巴斯克辣椒",
    "description": "红塔巴斯克辣椒是茄科植物，是塔巴斯克辣椒的成熟品种。果实红色，辣度中高，用于制作塔巴斯克辣酱。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "rice": {
    "name": "水稻",
    "description": "水稻是禾本科植物，原产于亚洲。颗粒富含碳水化合物、蛋白质和维生素，是世界主要粮食作物之一。",
    "sun_requirements": "全日照",
    "sowing_method": "育苗移栽"
  },
  "rocoto-pepper": {
    "name": "罗科托辣椒",
    "description": "罗科托辣椒是茄科植物，原产于南美洲。果实圆形，辣度极高，带有独特的果香和苹果香气。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "romaine-lettuce": {
    "name": "罗马生菜",
    "description": "罗马生菜是菊科植物，原产于地中海地区。叶片长而直立，质地脆嫩，富含维生素A和K，是凯撒沙拉的主要食材。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种或育苗移栽"
  },
  "rosemary": {
    "name": "迷迭香",
    "description": "迷迭香是唇形科多年生灌木，原产于地中海地区。叶片针状芳香，富含抗氧化物质，常用于烤肉、土豆和面包的调味。",
    "sun_requirements": "全日照",
    "sowing_method": "育苗移栽"
  },
  "runner-bean": {
    "name": "红花菜豆",
    "description": "红花菜豆是豆科植物，原产于中美洲。藤蔓攀援，花朵红色，豆荚大型，富含蛋白质和膳食纤维。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "russet-potato": {
    "name": "褐皮土豆",
    "description": "褐皮土豆是茄科植物，块茎外皮褐色，果肉白色，富含淀粉和维生素C，是常见的烹饪土豆品种。",
    "sun_requirements": "全日照",
    "sowing_method": "种植块茎或种薯"
  },
  "rutabaga": {
    "name": "芜菁甘蓝",
    "description": "芜菁甘蓝是十字花科植物，原产于欧洲。根部大型黄紫色，质地甜嫩，富含维生素C和钾，口感类似萝卜和土豆。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "rye": {
    "name": "黑麦",
    "description": "黑麦是禾本科植物，原产于西亚。颗粒富含膳食纤维、蛋白质和矿物质，是重要的粮食和酿造原料。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "sage": {
    "name": "鼠尾草",
    "description": "鼠尾草是唇形科多年生草本植物，原产于地中海地区。叶片灰绿色，香气浓郁，富含精油和抗氧化物质，常用于肉类料理。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "salsify": {
    "name": "婆罗门参",
    "description": "婆罗门参是菊科植物，原产于欧洲。根部白色细长，口感类似牡蛎，富含膳食纤维和矿物质，是特色蔬菜。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "santa-fe-grande-pepper": {
    "name": "圣达菲辣椒",
    "description": "圣达菲辣椒是茄科植物，原产于新墨西哥州。果实细长，辣度中低，果肉厚实，常用于墨西哥菜。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "savoy-cabbage": {
    "name": "皱叶卷心菜",
    "description": "皱叶卷心菜是十字花科植物，原产于欧洲。叶片紧密包裹成球状，表面皱褶，质地脆嫩，富含维生素C和膳食纤维。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "shallot": {
    "name": "红葱头",
    "description": "红葱头是百合科植物，鳞茎小型紫红色，带有浓郁的洋葱大蒜香气，富含硫化物，广泛用于烹饪和调味。",
    "sun_requirements": "全日照",
    "sowing_method": "种植鳞茎"
  },
  "shiitake-mushroom": {
    "name": "香菇",
    "description": "香菇是光柄菇科真菌，原产于东亚。菌盖褐色，质地嫩滑，富含蛋白质、膳食纤维和多糖，是重要的食用菌。",
    "sun_requirements": "半阴",
    "sowing_method": "菌丝培养"
  },
  "shishito-pepper": {
    "name": "狮子头辣椒",
    "description": "狮子头辣椒是茄科植物，原产于日本。果实细长，辣度较低，偶尔有辣的，常用于烤制和日式料理。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "siling-labuyo-pepper": {
    "name": "西林拉布约辣椒",
    "description": "西林拉布约辣椒是茄科植物，原产于菲律宾。果实小型，辣度高，广泛用于菲律宾料理。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "snap-pea": {
    "name": "甜豌豆",
    "description": "甜豌豆是豆科植物，原产于地中海地区。豆荚脆嫩可食，豆粒饱满香甜，富含蛋白质和维生素C。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "soybean": {
    "name": "大豆",
    "description": "大豆是豆科植物，原产于东亚。豆粒富含优质蛋白质、异黄酮和健康脂肪，是世界重要油料作物和蛋白质来源。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "spaghetti-squash": {
    "name": "意面南瓜",
    "description": "意面南瓜是葫芦科植物，原产于亚洲。果实椭圆形，果肉煮熟后呈丝状如面条，富含维生素A和β-胡萝卜素。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "spinach": {
    "name": "菠菜",
    "description": "菠菜是苋科植物，原产于波斯（今伊朗）。叶片深绿色，质地柔软，富含铁、钙和维生素，被誉为'营养之王'，是极好的绿叶蔬菜。",
    "sun_requirements": "半阴到全日照",
    "sowing_method": "直接播种"
  },
  "spring-onion": {
    "name": "春葱",
    "description": "春葱是百合科植物，是葱的嫩芽。茎叶皆可食用，带有温和的葱香，富含维生素C，广泛用于亚洲料理。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "st-johns-wort": {
    "name": "圣约翰草",
    "description": "圣约翰草是藤黄科植物，原产于欧洲。叶片黄色，花朵金黄色，含有金丝桃素，具有抗抑郁功效。",
    "sun_requirements": "全日照",
    "sowing_method": "育苗移栽或播种"
  },
  "stevia": {
    "name": "甜菊",
    "description": "甜菊是菊科多年生草本植物，原产于南美洲。叶片甜度高而低热量，富含甜菊糖苷，是天然代糖。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "育苗移栽或播种"
  },
  "strawberry": {
    "name": "草莓",
    "description": "草莓是蔷薇科多年生植物，原产于美洲。果实鲜红艳丽，口感香甜，富含维生素C和抗氧化物质，是最受欢迎的水果之一。",
    "sun_requirements": "全日照",
    "sowing_method": "育苗移栽"
  },
  "striped-cavern-tomato": {
    "name": "条纹空心番茄",
    "description": "条纹空心番茄是茄科植物，果实大型，内部空腔，带有条纹，肉质丰厚，口感独特。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "sugarcane": {
    "name": "甘蔗",
    "description": "甘蔗是禾本科植物，原产于东南亚。茎杆高大，汁液甜美，富含蔗糖，是世界主要糖料作物之一。",
    "sun_requirements": "全日照",
    "sowing_method": "种植茎段"
  },
  "sunflower": {
    "name": "向日葵",
    "description": "向日葵是菊科一年生草本植物，原产于北美洲。花盘硕大金黄，种子可食用榨油，花朵随太阳转动，极具观赏价值。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "sunray-tomato": {
    "name": "阳光番茄",
    "description": "阳光番茄是茄科植物，果实黄色大型，肉质丰厚，口感甜美，富含番茄红素和维生素C。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "sweet-italian-pepper": {
    "name": "甜意大利辣椒",
    "description": "甜意大利辣椒是茄科植物，原产于意大利。果实细长，辣度低，果肉厚实甜嫩，广泛用于意大利料理。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "sweet-potato": {
    "name": "红薯",
    "description": "红薯是旋花科植物，原产于南美洲。块茎富含淀粉、β-胡萝卜素和维生素A，口感香甜软糯，是世界重要粮食作物。",
    "sun_requirements": "全日照",
    "sowing_method": "种植藤蔓或块茎"
  },
  "swiss-chard": {
    "name": "瑞士甜菜",
    "description": "瑞士甜菜是苋科植物，原产于地中海地区。叶柄白色或彩色，叶片深绿色，质地脆嫩，富含维生素K和矿物质。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "taro": {
    "name": "芋头",
    "description": "芋头是天南星科植物，原产于东南亚。块茎富含淀粉，质地软糯，富含膳食纤维和维生素，口感清淡。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "种植块茎"
  },
  "thyme": {
    "name": "百里香",
    "description": "百里香是唇形科多年生草本植物，原产于欧洲南部。叶片细小芳香，富含精油和抗氧化物质，是西式料理和烤肉的重要香料。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "tomatillo": {
    "name": "墨西哥绿番茄",
    "description": "墨西哥绿番茄是茄科植物，原产于墨西哥。果实被绿色纸质花苞包裹，质地酸甜，富含维生素C，是墨西哥料理的重要食材。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "tomato": {
    "name": "番茄",
    "description": "番茄是茄科植物，原产于南美洲。果实生长在紧凑的灌木上，有红色、黄色、橙色等多种颜色，是世界上最受欢迎的蔬菜之一。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "trinidad-moruga-scorpion-pepper": {
    "name": "特立尼达莫鲁加蝎子椒",
    "description": "特立尼达莫鲁加蝎子椒是茄科植物，原产于特立尼达和多巴哥。果实红色，辣度极高，曾是世界最辣辣椒之一。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "trinidad-scorpion-butch-t-pepper": {
    "name": "特立尼达蝎子椒",
    "description": "特立尼达蝎子椒是茄科植物，原产于特立尼达和多巴哥。果实红色，辣度极高，带有独特的果香和巧克力香气。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "trumpet-mushroom": {
    "name": "喇叭菇",
    "description": "喇叭菇是菌菇科真菌，菌盖喇叭状，质地嫩滑，富含蛋白质和膳食纤维，是特色食用菌。",
    "sun_requirements": "半阴",
    "sowing_method": "菌丝培养"
  },
  "tulsi": {
    "name": "圣罗勒",
    "description": "圣罗勒是唇形科多年生草本植物，原产于印度。叶片芳香，富含抗氧化物质，在印度教中是神圣植物，具有保健功效。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "育苗移栽或播种"
  },
  "turmeric": {
    "name": "姜黄",
    "description": "姜黄是姜科植物，原产于南亚。根部橙黄色，富含姜黄素，具有抗炎、抗氧化等保健功效，广泛用于印度料理。",
    "sun_requirements": "半阴到全日照",
    "sowing_method": "种植根茎"
  },
  "turnip": {
    "name": "大头菜",
    "description": "大头菜是十字花科植物，原产于欧洲。根部紫色或白色，质地甜嫩，富含维生素C和钾，叶也可食用。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "watercress": {
    "name": "豆瓣菜",
    "description": "豆瓣菜是十字花科植物，原产于欧洲。生长在水中，叶片深绿，口感辛辣清香，富含维生素K和矿物质。",
    "sun_requirements": "半阴",
    "sowing_method": "播种或扦插"
  },
  "watermelon": {
    "name": "西瓜",
    "description": "西瓜是葫芦科植物，原产于非洲。果实巨大，果肉红嫩多汁，含水量高达92%，富含维生素A、C和番茄红素，是夏季消暑佳果。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "watermelon-radish": {
    "name": "西瓜萝卜",
    "description": "西瓜萝卜是十字花科植物，原产于中国。根部外部绿色，内部红色，口感甜脆，富含维生素C。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "wax-bean": {
    "name": "黄四季豆",
    "description": "黄四季豆是豆科植物，豆荚黄色，口感脆嫩，富含蛋白质和维生素C，是常见的豆类蔬菜。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "wheat": {
    "name": "小麦",
    "description": "小麦是禾本科植物，原产于西亚。颗粒富含蛋白质、碳水化合物和膳食纤维，是世界主要粮食作物之一。",
    "sun_requirements": "全日照",
    "sowing_method": "直接播种"
  },
  "white-button-mushroom": {
    "name": "白蘑菇",
    "description": "白蘑菇是蘑菇科真菌，是双孢菇的白色品种。菌盖白色，质地嫩滑，富含蛋白质和硒，是常见食用菌。",
    "sun_requirements": "半阴",
    "sowing_method": "菌丝培养"
  },
  "white-carrot": {
    "name": "白胡萝卜",
    "description": "白胡萝卜是伞形科植物，是胡萝卜的白色品种。根部白色，质地甜嫩，富含胡萝卜素和维生素C。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "white-onion": {
    "name": "白洋葱",
    "description": "白洋葱是百合科植物，鳞茎白色，带有温和的辛辣味，富含硫化物和维生素C，常用于生食和烹饪。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "white-oyster-mushroom": {
    "name": "白平菇",
    "description": "白平菇是侧耳科真菌，原产于亚洲。菌盖白色如贝壳，质地嫩滑，富含蛋白质和膳食纤维，是常见食用菌。",
    "sun_requirements": "半阴",
    "sowing_method": "菌丝培养"
  },
  "wormwood": {
    "name": "苦艾",
    "description": "苦艾是菊科多年生草本植物，原产于欧洲。叶片灰绿色，带有苦味和独特香气，富含苦艾素，用于制作苦艾酒。",
    "sun_requirements": "全日照",
    "sowing_method": "育苗移栽或播种"
  },
  "yellow-bell-pepper": {
    "name": "黄甜椒",
    "description": "黄甜椒是茄科植物，是甜椒的黄色品种。果实大型，辣度低，果肉厚实，富含维生素C和胡萝卜素。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "yellow-carrot": {
    "name": "黄胡萝卜",
    "description": "黄胡萝卜是伞形科植物，是胡萝卜的黄色品种。根部黄色，富含胡萝卜素和维生素C，口感甜嫩。",
    "sun_requirements": "全日照到半阴",
    "sowing_method": "直接播种"
  },
  "yellow-cauliflower": {
    "name": "黄花椰菜",
    "description": "黄花椰菜是十字花科植物，是花椰菜的黄色品种。花蕾黄色紧密，富含β-胡萝卜素和维生素C，营养密度极高。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "yellow-onion": {
    "name": "黄洋葱",
    "description": "黄洋葱是百合科植物，鳞茎黄色，带有浓郁的辛辣味，富含硫化物和槲皮素，广泛用于烹饪。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "yellow-oyster-mushroom": {
    "name": "黄平菇",
    "description": "黄平菇是侧耳科真菌，原产于亚洲。菌盖黄色，质地嫩滑，富含蛋白质和膳食纤维，是特色食用菌。",
    "sun_requirements": "半阴",
    "sowing_method": "菌丝培养"
  },
  "yellow-scotch-bonnet": {
    "name": "黄苏格兰圆帽辣椒",
    "description": "黄苏格兰圆帽辣椒是茄科植物，果实扁圆形黄色，辣度极高，带有独特的果香和花香。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "yellow-squash": {
    "name": "黄西葫芦",
    "description": "黄西葫芦是葫芦科植物，原产于美洲。果实黄色长条形，皮薄肉嫩，富含维生素C和钾，口感清爽。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  },
  "yukon-gold-potato": {
    "name": "育空黄金土豆",
    "description": "育空黄金土豆是茄科植物，块茎外皮黄色，果肉金黄色，富含淀粉和维生素C，口感香甜，是优质烹饪土豆。",
    "sun_requirements": "全日照",
    "sowing_method": "种植块茎或种薯"
  },
  "zucchini": {
    "name": "西葫芦",
    "description": "西葫芦是葫芦科植物，原产于墨西哥。果实为绿色长条形，皮薄肉嫩，富含维生素C和钾，口感清爽。",
    "sun_requirements": "全日照",
    "sowing_method": "室内播种育苗，幼苗经过炼苗后移栽到室外"
  }
}
